<template>
  <v-card tile class="header">
    <v-toolbar dense>
      <v-app-bar-nav-icon @click.stop="toggleSidebar" class="sidebarToggler" v-if="isLoggedIn"><v-icon>menu</v-icon></v-app-bar-nav-icon>
      <v-toolbar-title :class="'ml-0' + (isLoggedIn ? ' pl-3' : ' pl-1')">
        <span v-show="$vuetify.breakpoint.smAndUp" @click="reloadPage" class="header" style="cursor: pointer;">{{ headerName }}</span>
        <span v-if="environment" style="color: red; margin-left: 50px;">{{ environment }}</span>
      </v-toolbar-title>
      <span class="pageTitle v-toolbar__title">{{ pageTitle }}</span>
      <v-spacer/>
      <v-btn @click="endImpersonation" v-if="isImpersonating" class="btnEndImpersonation">{{ $t('header.button.endImpersonation') }}</v-btn>
      <span class="hidden-xs-only selectable" @click="preferencesDialog = true" v-if="isLoggedIn">{{ fullName }}</span>
      <v-icon class="signout" :title="$t('header.logout')" @click="logout" v-if="isLoggedIn">power_settings_new</v-icon>
      <v-snackbar v-model="snackbar" :timeout='3000' top right>{{ snackbarMessage }}</v-snackbar>
      <v-progress-linear :active="progressBar" absolute bottom :value="progressBarValue" :indeterminate="progressBarIndeterminate" height="2" color="white" background-opacity="0" class="progressBar"/>
    </v-toolbar>
    <v-dialog v-model="preferencesDialog" class="preferencesDialog" persistent width="400">
      <v-card>
        <v-card-title class="headline">{{ $t('header.dialog.preferences.header') }}</v-card-title>
        <v-card-text style="padding-top: 10px !important; padding-bottom: 0 !important;">
          <v-container>
            <v-layout>
              <v-flex xs6>
                {{ $t('header.dialog.preferences.language') }}
              </v-flex>
              <v-flex xs6>
                <v-select outlined :items="allLanguages" v-model="language" item-text="label" item-value="key" @change="changeLanguage" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="preferencesDialog = false">{{ $t('button.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import i18n from '@/plugins/i18n'
import language from '@/assets/javascript/language'

export default {
  name: 'Header',
  props: {
    title: {}
  },
  data () {
    return {
      preferencesDialog: false,
      language: null,
      languages: [ 'en', 'da' ],
      snackbar: false,
      snackbarMessage: '',
      progressBar: false,
      progressBarValue: 0,
      progressBarIndeterminate: false
    }
  },
  created () {
    this.language = i18n.locale
  },
  methods: {
    toggleSidebar: function () {
      this.$store.dispatch('sidebar/toggle')
    },
    showSnackbar: function (message) {
      this.snackbarMessage = message
      this.snackbar = true
    },
    logout () {
      this.$store.dispatch('session/logout')
      this.$store.dispatch('page/setSidebarItem', {})
      this.$router.push({ name: 'Login' })
    },
    reloadPage () {
      window.location.reload()
    },
    changeLanguage () {
      // console.log('Setting language to: ' + this.language)
      language.setLanguage(this.language)
    },
    endImpersonation () {
      this.$store.dispatch('session/endImpersonation', {})
        .then((response) => {
          this.$store.dispatch('page/setSidebarItem', { key: 'dashboard' })
          this.$router.push({ name: 'Dashboard' })
        })
        .catch((error) => {
          console.log('Error: \'' + error.message + '\'')
        })
    },
    startProgressBar () {
      this.progressBarValue = 0
      this.progressBarIndeterminate = false
      this.progressBar = true
    },
    updateProgressBar (value) {
      this.progressBarValue = value
    },
    setProgressBarIndeterminate (indeterminate) {
      this.progressBarIndeterminate = indeterminate
    },
    stopProgressBar () {
      this.progressBar = false
    }
  },
  computed: {
    fullName: function () {
      return this.$store.state.session.fullName
    },
    pageTitle: function () {
      return this.$store.state.page.title
    },
    environment: function () {
      let runMode = ''
      return runMode === 'PRODUCTION' ? '' : runMode === 'TEST' ? 'Test' : runMode === 'QA' ? 'QA' : runMode === 'DEVELOPMENT' ? 'Development' : ''
    },
    isImpersonating: function () {
      return this.$store.getters['session/isImpersonating']
    },
    isLoggedIn: function () {
      return this.$store.getters['session/isLoggedIn']
    },
    isSuperAdmin: function () {
      return this.$store.getters['session/isSuperAdmin']
    },
    allLanguages: function () {
      let result = []
      for (let lang of this.languages) {
        result.push({
          key: lang,
          label: this.$t('language.' + lang)
        })
      }
      return result
    },
    headerName: function () {
      return this.title ? this.title : this.$store.state.session.organizationName ? this.$store.state.session.organizationName : this.isSuperAdmin ? 'System administration' : ''
    }
  }
}
</script>

<style scoped>
  .pageTitle {
    padding-left: 60px;
  }
  .signout {
    font-size: 18px;
    padding-left: 15px;
    cursor: pointer;
    color: white;
  }
  span.header {
    font-size: 22px;
  }
  div.header {
    box-shadow: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue